import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ServiceStatisticsTimelineRowDTO } from '../../dto/ServiceStatisticsDTO';
import { dayPoint, shortDayLabel } from './periodDetail';
import { buildTimeline, formatInt, formatMinutes, TimelinePoint } from './statisticsUtils';

interface PeriodDetailDaysProps {
    /** Un día por fila; los días sin atenciones no vienen del backend. */
    rows: ServiceStatisticsTimelineRowDTO[];
    from: string;
    to: string;
    /** Tocar un día abre ese día en el mismo panel. */
    onSelectDay: (point: TimelinePoint) => void;
}

/** «Por día»: los días de una semana o un mes, con sus atenciones y su espera media; tocar uno abre ese día. */
export default function PeriodDetailDays({ rows, from, to, onSelectDay }: PeriodDetailDaysProps) {
    const intl = useIntl();
    const days = useMemo(() => buildTimeline(rows, from, to, 'DAY'), [rows, from, to]);

    if (days.length === 0 || days.every(day => day.attentions === 0)) {
        return <p className="nv-muted">{intl.formatMessage({ id: 'ServicesStatisticsPeriodDetailHoursEmpty' })}</p>;
    }
    return (
        <ul className="ss-detail__days">
            {days.map(day => (
                <li key={day.period}>
                    {day.attentions > 0 ? (
                        <button type="button" className="ss-detail__day ss-detail__day--action"
                            onClick={() => onSelectDay(dayPoint(day.start, day.attentions, day.avgWait, day.avgService))}>
                            <span className="ss-detail__day-name">{shortDayLabel(intl, day.start)}</span>
                            <span className="ss-detail__num">
                                {intl.formatMessage({ id: 'ServicesStatisticsPeriodDetailDayAttentions' },
                                    { count: day.attentions, countText: formatInt(day.attentions) })}
                            </span>
                            <span className="ss-detail__num">{formatMinutes(day.avgWait)}</span>
                            <i className="pi pi-angle-right" aria-hidden="true" />
                        </button>
                    ) : (
                        <div className="ss-detail__day ss-detail__day--empty">
                            <span className="ss-detail__day-name">{shortDayLabel(intl, day.start)}</span>
                            <span className="ss-detail__none">{intl.formatMessage({ id: 'ServicesStatisticsNoAttentions' })}</span>
                        </div>
                    )}
                </li>
            ))}
        </ul>
    );
}
